module.exports = __webpack_public_path__ + "e92554f65cdce9b74da405cd30b2b3cc.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/angry-16.png
// module id = 1970
// module chunks = 0